<template>
  <article v-qa="'offline_office_contact'" class="office-card">
    <contacts-section>
      <template #title>
        <h2 class="sf-sb">{{ office.title }}</h2>
      </template>

      <contacts-group v-for="item in office.data" :key="item.key" class="group">
        <template #logo><component :is="item.logo"/></template>

        <h3 class="group__title">{{ item.title }}</h3>

        <p class="group__text">{{ item.daysText }}</p>
        <p class="group__text">{{ item.hoursText }}</p>
        <p class="group__text">{{ item.address }}</p>

        <button v-if="item.isMap" class="toggle-btn sf-mt-s" @click="isShowMap = !isShowMap">
          {{ toggleBtnText }}
        </button>
      </contacts-group>
    </contacts-section>

    <contacts-map v-model="isShowMap" :img="office.mapImage"/>
  </article>
</template>

<script>
import ContactsGroup from '~/components/contacts/contacts-group.vue';
import ContactsMap from '~/components/contacts/contacts-map.vue';
import ContactsSection from '~/components/contacts/contacts-section.vue';

export default {
  name: 'OfflineOfficeContact',
  components: { ContactsMap, ContactsSection, ContactsGroup },

  props: {
    office: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isShowMap: false,
    };
  },

  computed: {
    toggleBtnText() {
      return !this.isShowMap ? this.$t('offices-page.open-map-btn') : null;
    },
  },
};
</script>

<style scoped lang="scss">
.office-card {
  &:not(:last-child) {
    margin-bottom: 2rem;
  }
}

.group {
  &__title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: map-get($margins, small);
  }

  &__text {
    font-size: 18px;
    font-weight: 400;
    margin-bottom: 0;
  }
}

.toggle-btn {
  text-transform: uppercase;
  text-decoration: underline;
  cursor: pointer;
  color: color(secondary);
  font-size: 16px;
  font-weight: 700;
  background: transparent;
}

.info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 1rem;

  &__title {
    font-size: 20px;
    font-weight: 600;
    margin: 0;
    padding: 0;
  }
}
</style>
